export default __webpack_public_path__ + "static/media/Spectrum-InternalDocumentation.ccb75d3d.png";